class Cache {

  constructor () {

  }

  get(key) {

    const value = localStorage.getItem(`cache.${key}`);

    if(value) {
      return JSON.parse(value);
    } else {
      return null;
    }

  }

  /**
   *
   * @param key
   * @param value
   */
  save(key, value) {

    try {
      const cacheItem = {
        timestamp: Date.now(),
        value,
      };

      localStorage.setItem(`cache.${key}`, JSON.stringify(cacheItem));

    } catch (e) {
      console.error("Error saving cache", e);
    }

  }

  remove(key) {
    localStorage.removeItem(`cache.${key}`);
  }

}

const CacheInstance = new Cache();

export default CacheInstance;
